import { render, staticRenderFns } from "./GripAnalysisCompressedNavigationTabs.vue?vue&type=template&id=323fb441"
import script from "./GripAnalysisCompressedNavigationTabs.vue?vue&type=script&lang=ts"
export * from "./GripAnalysisCompressedNavigationTabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports